import { HttpDownloadBlobRequest } from '@infrastructure/axios/http-download-blob-request';

export default class DownloadUserDocPdfUseCase extends HttpDownloadBlobRequest<Blob> {
  public async execute(docId: number | string): Promise<Blob> {
    return (await this.dispatch(`/docs/${docId}/pdf`)).data;
  }
}
